import type {MenuOption} from '@spaced-out/ui-design-system/lib/components/Menu/Menu';


export const mergeTypeaheadSelectedOption = (
  options: Array<MenuOption>,
  selected: {id: string; label: string} | null,
): Array<MenuOption> => {
  if (!selected?.id) {
    return options;
  }
  const key = String(selected.id);
  if (options.some((option) => option.key === key)) {
    return options;
  }
  return [{key, label: selected.label ?? ''}, ...options];
};
